module.exports = __webpack_public_path__ + "static/scale-model-of-oakland-zoo-in-oakland-california-22912bac76ce78ef95e2777fcfc9237d.png";